<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.description != '', 'has-danger' : validation.description != '' }">
                                        <label for="description" class="bmd-label-floating">Descrição *</label>
                                        <input refs="description" type="text" class="form-control" v-model="form.description" />
                                        <label v-if="validation.description != ''" id="description-error" class="error" for="description">{{ validation.description }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'pending-reasons.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    description: ''
                },
                validation: {
                    description: ''
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.description = '';

                if (self.form.description == '') {
                    self.validation.description = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid){
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('pending_reasons/add', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Razão de pendência cadastrada com sucesso!");
                        self.$router.push({'name': 'pending-reasons.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.status !== undefined) {
                                self.validation.status = err.data.errors.status[0];
                            }
                        }
                    });
                }
                _ev.preventDefault();
            }
        }
    };
</script>